import { Holiday } from "../../types/Holiday";
import { HolidayAction, HolidayActionType } from "../actions/holidayAction";

const initialState: Holiday[] = [];

const holidayReducer = (
  state = initialState,
  action: HolidayAction,
): Holiday[] => {
  switch (action.type) {
    case HolidayActionType.FETCH_HOLIDAYS:
      return action.data;

    case HolidayActionType.ADD_HOLIDAY:
      return [...state, action.data];

    case HolidayActionType.EDIT_HOLIDAY:
      return state.map((h) => (h.id === action.data.id ? action.data : h));

    case HolidayActionType.DELETE_HOLIDAY:
      return state.filter((h) => h.id !== action.data);

    default:
      return state;
  }
};

export default holidayReducer;
